import { render, staticRenderFns } from "./indexTip.vue?vue&type=template&id=5852bdb6&scoped=true"
import script from "./indexTip.vue?vue&type=script&lang=js"
export * from "./indexTip.vue?vue&type=script&lang=js"
import style0 from "./indexTip.vue?vue&type=style&index=0&id=5852bdb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5852bdb6",
  null
  
)

export default component.exports